var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApiErrorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.891,
    height: 26.262,
    viewBox: "0 0 30.891 26.262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "error-icon-API",
    transform: "translate(-714 -35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "danger",
    transform: "translate(714 35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9380",
    "data-name": "Group 9380"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37528",
    "data-name": "Path 37528",
    d: "M30.62,61.757,17.067,39.28a1.893,1.893,0,0,0-3.242,0L.272,61.757a1.893,1.893,0,0,0,1.621,2.87H29a1.893,1.893,0,0,0,1.621-2.87ZM15.456,46.14a1.283,1.283,0,0,1,1.437,1.217c0,2.375-.279,5.788-.279,8.163,0,.619-.679.878-1.158.878-.639,0-1.177-.259-1.177-.878,0-2.375-.279-5.788-.279-8.163C14,46.579,14.638,46.14,15.456,46.14Zm.02,14.709a1.537,1.537,0,1,1,1.517-1.537A1.56,1.56,0,0,1,15.476,60.849Z",
    transform: "translate(0 -38.365)",
    fill: "#e64c2b"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiErrorIcon);
export default __webpack_public_path__ + "static/media/apiErrorIcon.3b1ae54f.svg";
export { ForwardRef as ReactComponent };